import { useQuery } from '@tanstack/react-query';

const publicToken = '71ad26d7aaf410e39efe91bd414d32e1db5d';

function utcFormatted(date) {
  return date
    .toISOString()
    .replace(/[^0-9]/g, '')
    .slice(0, 12);
}

const fetchObservations = async (stations) => {
  const start = new Date();
  const end = new Date(start - 7 * 24 * 60 * 60 * 1000);
  const startDate = utcFormatted(end);
  const endDate = utcFormatted(start);
  const stationString = stations.join(',');
  const response = await fetch(
    `https://api.snowobs.com/wx/v1/station/data/timeseries/?token=${publicToken}&stid=${stationString}&source=nwac&start_date=${startDate}&end_date=${endDate}`
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useObservations = (location) => {
  return useQuery({
    queryKey: ['observations', location.name],
    queryFn: () => fetchObservations(location.nwacStations),
    // Stale after 1 hour
    staleTime: 2 * 60 * 60 * 1000,
  });
};
